'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var _views = require('../constants/views');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _views.THREAD_LIST;

var currentView = (0, _reduxActions.handleActions)(_defineProperty({}, _actionTypes.UPDATE_VIEW, function (state, action) {
  var view = action.payload.view;


  return view;
}), initialState);

exports.default = currentView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/current-view/reducers/currentView.js
// module id = 1284
// module chunks = 3